import { Modify } from "../utilities/modifyType";
import { deserializePremiumSermonSeriesAsset, PremiumSermonSeriesAsset, SerializedPremiumSermonSeriesAsset }  from "./PremiumSermonSeriesAsset";

export interface PremiumSermonSeries {
    id: number;
    name: string;
    shortDescription: string;
    description: string;   
    isDisabled: boolean;
    isFree: boolean;
    thumbnailUrl: string;
    assets: PremiumSermonSeriesAsset[];
    activations: number;
    dateCreated: Date;
}

export type SerializedPremiumSermonSeries = Modify<PremiumSermonSeries, {
    dateCreated: string;
    assets?: SerializedPremiumSermonSeriesAsset[];
}>

export function deserializePremiumSermonSeries(premiumSermonSeries:SerializedPremiumSermonSeries) : PremiumSermonSeries {
    return {
        ...premiumSermonSeries,
        dateCreated: new Date(premiumSermonSeries.dateCreated),
        assets: premiumSermonSeries.assets ? premiumSermonSeries.assets.map(deserializePremiumSermonSeriesAsset) : []
    }
}
